$(document).ready(function () {

    $('.go-to-request-cart-form').click(function () {
        $('.request-cart-cart-container').addClass('hidden');
        $('.request-cart-form-fields').removeClass('hidden');

        return false;
    });

    $('.go-back-to-request-cart').click(function () {
        $('.request-cart-cart-container').removeClass('hidden');
        $('.request-cart-form-fields').addClass('hidden');

        return false;
    });

    // change quantity
    $('.request-cart-item-quantity-change').change(function () {
        $('#isOverlay').toggleClass('d-none');
        var position = $(this).parents('.position-container').data('position');
        var quantity = $(this).val();
        axios.post(window.config.urls.requestCart + '/update-quantity', {
            position: position,
            quantity: quantity,
        }).then(({data}) => {
            $('#isOverlay').toggleClass('d-none');
        }).catch(function(){
            $('#isOverlay').toggleClass('d-none');
        });
    })

    // update request mini cart quantity
    $(document).on('change', '.request-mini-cart .request-cart-item-quantity-change', function () {
        let position = $(this).data('position');
        let quantity = $(this).val();
        axios.post(window.config.urls.requestCart + '/update-quantity', {
            position: position,
            quantity: quantity,
        });
    })

    // delete request mini cart item
    $(document).on('click', '.request-mini-cart .delete-request-cart-item', function () {
        let position = $(this).data('position');
        axios.post(window.config.urls.requestCart + '/remove-position/' + position);
        $(this).closest('.is-mini-cart-item').remove();
    })

    // add to cart ajax
    $(document).on('submit', '.add-product-to-request-cart-form', function () {

        // product info
        var product_id = $(this).data('product-id');
        var quantity = $('.detail-item-quantity-change').val();
        var configuration = '';
        var configurable = false;

        // validate configuration
        try {
            $('#configuration_quantity_' + product_id).val(quantity);
            configurable = true;
        } catch (error) {
            console.log("product is not configurable");
        }

        // configuration
        if(window.K1_NPC && configurable) {
            var config = window.K1_NPC.getCurrentConfig(product_id);
            if (!config.valid) {
                alert('Please configure');
                return false;
            } else {
                if (config.properties) {
                    $('#configuration_' + product_id).val(JSON.stringify(config.properties));
                    configuration = $('#configuration_' + product_id).val();
                } else {
                    $('#configuration_' + product_id).val(JSON.stringify({}));
                }
            }
        }

        // add to cart
        $.ajax({
            url: $(this).prop('action'),
            data: {
                config: configuration,
                quantity: quantity,
            },
        }).done(function (data) {
            // show modal
            let modal = $('#addToRequestCartModal');
            modal.find('#addToRequestCartModalContent').html(data.content);
            modal.modal('show');

            updateRequestCart();
        });
        return false;
    });

    // request count
    updateRequestCart();

    // request cart header icon
    $(document).on('click', '.is-header .mini-cart-btn, .is-main-navigation-bar .mini-cart-btn', function () {
        return false;
    });

});

let image_html = function (item) {
    if (item.image) {
        return `<img src="${item.image}" class="img-fluid" title="${item.name}" alt="${item.name}">`;
    } else {
        return `<div class="is-no-image"><i class="fal fa-image is-icon--xl"></i></div>`;
    }
}

xBomToCart = function (data) {
    addItemsToRequestCart(data);
    return true;
}

addItemsToRequestCart = function (data) {
    $.ajax({
        url: window.config.urls.requestCart + '/addProductsAjax',
        data: {items: JSON.stringify(data)},
        method: 'post',
    }).done(function (data) {
        // show modal
        let modal = $('#addToRequestCartModal');
        modal.find('#addToRequestCartModalContent').html(data.content);
        modal.modal('show');

        updateRequestCart();
    });
}

updateRequestCart = function () {
    let requestCounter = $('.request-counter');
    let requestMiniCartBody = $('#requestMiniCartBody');

    if (requestCounter.length) {
        let requestUrl = requestCounter.closest('a').data('request');
        $.ajax({
            url: requestUrl,
        }).done(function (data) {
            if (data.count > 0) {
                requestCounter
                    .removeClass('visually-hidden')
                    .html(data.count)
            }
            if(data.items) {
                requestMiniCartBody.html('');
                data.items.forEach(function (item, index) {
                    let name = '<h4 class="h6 mb-0">' + item.name + '</h4>';
                    let details = item.details ? '<small>' + item.details + '</small><br/>' : '';
                    let material_number = '<small>' + item.material_number + '</small><br/>';
                    let configuration = '<small>' + item.configuration + '</small>';

                    requestMiniCartBody.append(
                        `<div class="row fill-width m-0 is-mini-cart-item d-flex align-items-center border-bottom py-3">
                        <form method="post">
                            <input type="hidden" name="${item.rowId}[quantity]" value="" class="quantity">
                            <input type="hidden" name="${item.rowId}[rowId]" value="${item.rowId}" class="rowId">
                            <input type="hidden" name="${item.rowId}[id]" value="${item.id}" class="id">
                        </form>

                        <div class="col-2 is-mini-cart-item__image-wrap">
                            ${image_html(item)}
                        </div>

                        <div class="col-4">
                            ${name}
                            ${details}
                            ${material_number}
                        </div>

                        <div class="col-2 d-none d-md-block">
                            <span>${configuration}</span>
                        </div>

                        <div class="col-4 request-mini-cart text-end">
                            <div class="row">
                                <div class="col-8">
                                    <div class="syskomp-number-input d-inline-flex border">
                                        <button class="syskomp-number-input__up btn" >
                                            <i class="far fa-plus"></i>
                                        </button>
                                        <input
                                            class="syskomp-number-input__input text-center request-cart-item-quantity-change forced-horizontal"
                                            type="number"
                                            min="1"
                                            data-min="1"
                                            max="1000000"
                                            data-max="1000000"
                                            step="1"
                                            data-step="1"
                                            data-position="${item.position}"
                                            value="${item.quantity}"
                                          />
                                        <button class="syskomp-number-input__down btn forced-horizontal">
                                            <i class="far fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="text-end pt-1">
                                        <span>${item.quantityUnit}</span>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <button type="button" class="btn btn-icon-light px-1 delete-request-cart-item"
                                        data-cart-id="${data.cartId}"
                                        data-position="${item.position}"
                                        data-action="update-mini-cart">
                                        <i class="is-icon text-danger fas fa-times-circle"></i>
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>`
                    );
                });
            }
            if(data.message) {
                requestMiniCartBody.append(
                    `<div class="container border-info">
                        <div role="alert" class="alert alert-info">
                            ${data.message}
                        </div>
                    </div>`
                );
            }
        });
    }
}
